import React, { useEffect, useMemo } from 'react'
import styles from './styles.module.css'
import Button from '../../components/Button'
import { IoIosAdd } from 'react-icons/io'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { useState } from 'react'
import Modal from './Modal'
import Table from '../../components/Table'
import { BiTrash } from 'react-icons/bi'
import Confirmation from '../../components/Confirmation/Confirmation'
import { deleteSubjectsExtraEdu, getSubjectsExtraEdu } from '../../actions/directoryExtraEducation'
import { Checkbox } from '../../components/ModalInputs'
export default function SubjectsExtraEdu() {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { extraEduList } = useSelector(state => state.directoryExtraEducation)

  const [selectedItem, setSelectedItem] = useState(null)
  const [confirmation, setConfirmation] = useState(false);
  const [check, setCheck] = useState(false);
  const [sortField, setSortField] = useState('name')
  const [sortAsc, setSortAsc] = useState(true)

  useEffect(() => {
    dispatch(getSubjectsExtraEdu({ status: !check ? "Идет" : "Закрыт" }))
  }, [check])

  const handleSort = (field) => {
    if (sortField === field) setSortAsc(v => !v)
    else { setSortField(field); setSortAsc(true) }
  }

  const sortedList = useMemo(() => {
    if (!extraEduList) return []
    return [...extraEduList].sort((a, b) => {
      const aVal = a[sortField] ?? ''
      const bVal = b[sortField] ?? ''
      if (typeof aVal === 'number' && typeof bVal === 'number')
        return sortAsc ? aVal - bVal : bVal - aVal
      return sortAsc
        ? String(aVal).localeCompare(String(bVal), 'ru')
        : String(bVal).localeCompare(String(aVal), 'ru')
    })
  }, [extraEduList, sortField, sortAsc])

  const openModal = (data) => () => {
    setSelectedItem(data)
  }

  const closeModal = () => setSelectedItem(null)

  const goHome = () => navigate('/')

  const acceptConfirmation = () => {
    closeModal();
    dispatch(deleteSubjectsExtraEdu(confirmation.id));
    setConfirmation(false);
  };
  const rejectConfirmation = () => {
    setConfirmation(false);
  };

  const renderLi = (data) => {
    const { xp_key, name, status } = data
    return (
      <tr >
        <td onClick={openModal(data)}>{name}</td>
        <td onClick={openModal(data)}>{status}</td>
        <td><i className={styles.trash} onClick={() => setConfirmation({ id: xp_key, name })}><BiTrash /></i></td>
      </tr>
    )
  }


  return (
    <div className={styles.wrapper} style={{ width: '700px', margin: '0 auto' }}>
      {confirmation && (
        <Confirmation
          top="30px"
          left="40px"
          title={`Вы уверены, что хотите удалить ${confirmation.name}?`}
          acceptConfirmation={() => acceptConfirmation(confirmation?.xp_key)}
          rejectConfirmation={rejectConfirmation}
        />
      )}
      {selectedItem &&
        <Modal
          closeModal={closeModal}
          data={selectedItem}
          height={'430px'}
          addMode={selectedItem == 'add'}
        />
      }
      <h1>Предметы ДО</h1>
      {/* // TODO  когда АПИ будет готово переделать 20/11 */}
      <Checkbox
        label='С закрытыми'
        onChange={() => setCheck((prev) => !prev)}
      // style={{ margin: '15px' }}
      />
      <Table className={styles.tables}>
        <thead>
          <tr>
            <th onClick={() => handleSort('name')} style={{ cursor: 'pointer' }}>Название</th>
            <th onClick={() => handleSort('status')} style={{ cursor: 'pointer' }}>Статус</th>
            <th>Удалить</th>
            <th></th>
          </tr>
        </thead>
        <tbody>

          {sortedList?.map(renderLi)}

        </tbody>
      </Table>

      <div style={{ display: 'flex', flexDirection: "row" }}>
        <Button
          style={{ padding: '.5rem 1.5rem', margin: '12px' }}
          onClick={openModal('add')}
        >
          <IoIosAdd size={30} />
          Добавить
        </Button>
      </div>
    </div>
  )
}
